import { render, staticRenderFns } from "./GroupedErrors.vue?vue&type=template&id=9b26b970"
import script from "./GroupedErrors.vue?vue&type=script&lang=js"
export * from "./GroupedErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports